var map = {
	"./alipay--alipayhk.png": 2064,
	"./alipay--boost.png": 6100,
	"./alipay--fpx.png": 4027,
	"./alipay--grabpayMy.png": 887,
	"./alipay--grabpaySg.png": 2119,
	"./alipay--paynow.png": 6467,
	"./alipay--touch.png": 6872,
	"./igamebuy--igamebuy.png": 315,
	"./mycard.png": 7278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5522;